// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"328":"admin","343":"onboarding","674":"iso","710":"merchant","983":"payments"}[chunkId] + "." + {"328":"4edcf917","343":"6cbe3506","674":"3fe2fb77","710":"838adbb8","983":"4183f35d"}[chunkId] + ".css";
};